<template>
  <div>
    <a-spin :spinning="spinning">
      <a-carousel arrows>
        <div
          slot="prevArrow"
          slot-scope="props"
          class="custom-slick-arrow"
          style="left: 10px;zIndex: 1"
        >
          <a-icon type="left-circle" />
        </div>
        <div slot="nextArrow" slot-scope="props" class="custom-slick-arrow" style="right: 10px">
          <a-icon type="right-circle" />
        </div>
        <div v-if="urls.length === 1">
          <span>Fin del registro fotográfico.</span>
        </div>
        <div v-for="url in urls">
          <img :src="url && url.url" class="responsive" @click="modalShow(url)"/>
        </div>
      </a-carousel>
      <a-empty v-if="cantPhotos === 0">
        <span slot="description"> No hay registro fotográfico.</span>
      </a-empty>
      <a-modal :visible="visible" @cancel="handleCancel">
        <img alt="example" style="width: 100%" :src="currentUrl && currentUrl.url" />
        <template slot="footer">
          <div v-if="step == 0">
            <a-button key="back" @click="handleCancel">
              Cancelar
            </a-button>
            <a-button icon="delete" type="danger" :loading="loading" @click="handleDelete">
              Eliminar
            </a-button>
          </div>
          <span v-else />
        </template>
      </a-modal>
    </a-spin>
  </div>
</template>
<script>
  import HttpUtil from '@/util/HttpUtil'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'

  export default {
    props: ['id_attention', 'step'],
    async mounted () {
      this.httpClient = new HttpUtil()
      this.loadData()
    },
    data () {
      return {
        urls: [],
        visible: false,
        currentUrl: null,
        spinning: false,
        cantPhotos: -1,
        loading: false
      }
    },
    methods: {
      modalShow (url) {
        this.currentUrl = url
        this.visible = true
      },
      handleCancel () {
        this.visible = false
      },
      async getIdPictures () {
        return this.httpClient.getInstance().get('atention_call/files/' + this.id_attention)
      },
      loadPictures (id) {
        this.httpClient.getInstance().get('atention_call/file/' + id, {
          responseType: 'arraybuffer'
        })
          .then((response) => {
            let blob = new Blob([response.data], {type: response.headers['content-type']})
            this.urls.push({id: id, url: window.URL.createObjectURL(blob)})
          })
          .catch(() => {
            // no nos interesa
          })
      },
      handleDelete () {
        this.loading = true
        this.httpClient.getInstance().delete('atention_call_file/' + this.currentUrl.id, {
        })
          .then(() => {
            Mensajes.success('Exito', 'La foto se elimino correctamente.')
            this.urls.splice(this.urls.findIndex((i) => {
              return i.id === this.currentUrl.id
            }), 1)
            this.visible = false
          })
          .catch(() => {
            Mensajes.error('Error', 'No fue posible eliminar el registro.')
          }).then(() => {
            this.loading = false
          })
      },
      async loadData () {
        this.urls = []
        this.spinning = true
        let response = await this.getIdPictures()
        this.cantPhotos = response.data.length
        for (let value of response.data) {
          this.loadPictures(value)
        }
        this.spinning = false
      }
    },
    watch: {
      id_attention () {
        this.loadData()
      }
    }
  }
</script>

<style scoped>
  .responsive {
    width: 500px;
    height: 400px;
    align-content: center;
    margin-left: auto;
    margin-right: auto;
  }
  /* For demo */
  .ant-carousel >>> .slick-slide {
    text-align: center;
    height: 750px;
    line-height: 160px;
    overflow: hidden;
  }

  .ant-carousel >>> .custom-slick-arrow {
    width: 25px;
    height: 25px;
    font-size: 25px;
    /*color: #fff;*/
    color: black;
    background-color: rgba(31, 45, 61, 0.11);
    opacity: 0.3;
  }
  .ant-carousel >>> .custom-slick-arrow:before {
    display: none;
  }
  .ant-carousel >>> .custom-slick-arrow:hover {
    opacity: 0.5;
  }

  .ant-carousel >>> .slick-slide h3 {
    color: #fff;
  }
</style>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/ReporteNovedad/PhotoGraphicRecord.vue